/**
 * @generated SignedSource<<de3fabf41225a7bd0a2dac76507a0732>>
 * @relayHash 7adc3b0ca146bc4c96c94f3cfe06b763
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1fbf72075c57b45f24d27894283f0b352a75e329374812513a0103e67d6e3dfc

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_EditionAwarenessTrialModalQuery } from './main_EditionAwarenessTrialModalQuery.graphql';

const node: PreloadableConcreteRequest<main_EditionAwarenessTrialModalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1fbf72075c57b45f24d27894283f0b352a75e329374812513a0103e67d6e3dfc",
    "metadata": {},
    "name": "main_EditionAwarenessTrialModalQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
